import { useNavigate, useRouterState } from '@tanstack/react-router';
import { useState } from 'react';
import { Button } from '@evogard/ui';
import { claimClosureActionOf } from '@evogard/domain';
import { closurePhaseLabel } from './closureLabels.js';
import { ReopenModal } from './ReopenModal.js';
import { useClosurePermissions, type ReopenTarget } from './useClosures.js';

/**
 * Na mesa de quem já encerrou: não há para onde mover, e a mesa é só para
 * consulta (22/10/2026). A frase diz o que se pode fazer, pelo ato que o
 * desfecho aceita, e o botão faz ali mesmo — Reabrir a negativa e a
 * desistência, Acionar garantia no Concluído no Reparo. O concluído sem volta
 * só tem o histórico.
 */
export function ClosedNotice({ what, target }: { what: string; target: ReopenTarget }) {
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const { canReopen } = useClosurePermissions();
  const [reopening, setReopening] = useState(false);
  const action = claimClosureActionOf(target.origin, target.phase);
  const next =
    action === 'reabrir'
      ? 'para mudar alguma coisa, reabra-o'
      : action === 'garantia'
        ? 'para mudar alguma coisa, acione a garantia'
        : 'o processo terminou, e fica o histórico';
  return (
    <div className="flex flex-col items-start gap-2">
      <p className="text-sm text-texto-suave">
        {closurePhaseLabel(target.origin, target.phase)} encerra {what}: aqui é só para
        consulta, e {next}.
      </p>
      <div className="flex flex-wrap gap-2">
        {action && canReopen && (
          <Button size="sm" icon="atualizar" onClick={() => setReopening(true)}>
            {action === 'garantia' ? 'Acionar garantia' : 'Reabrir'}
          </Button>
        )}
        {path !== '/claims/closed' && (
          <Button
            size="sm"
            variant="discreto"
            onClick={() => void navigate({ to: '/claims/closed' })}
          >
            Ver em Encerrados
          </Button>
        )}
      </div>
      {reopening && <ReopenModal closure={target} onClose={() => setReopening(false)} />}
    </div>
  );
}
